import { ServiceUsingCountLimiter } from "@/services/license/license-limiters/base-limiters/service-using-count-limiter";
import { LicenseName } from "@/data/license.data";
import { getUserUniqueCustomVoicesSlotsLimit } from "@/actions/db/user-unique-dataset-limits";
import { getUserBasicQuotaTrainsCount } from "@/actions/db/train-voices";
import { customVoiceLicenseManager } from "@/services/license/license-managers/custom-voices-license-manager";

export class CustomVoiceUsingCountLimiter extends ServiceUsingCountLimiter {
  async getUniqueLimit(userId: string): Promise<number | null> {
    return getUserUniqueCustomVoicesSlotsLimit(userId);
  }

  isSlotsExpired = async (
    userId: string,
    license: LicenseName,
  ): Promise<boolean> => {
    const userBasicCustomVoices = await getUserBasicQuotaTrainsCount(userId);
    const customSlotsLimit =
      await customVoiceLicenseManager.serviceUsingCountLimiter.getUniqueLimit(
        userId,
      );
    if (customSlotsLimit) {
      return userBasicCustomVoices >= customSlotsLimit;
    }
    return userBasicCustomVoices >= this.getPlanLimit(license);
  };

  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Trial":
        return 1;
      case "Basic":
        return 1;
      case "Starter":
        return 2;
      case "Creator":
        return 6;
      case "Studio":
        return 20;
      case "Premium":
        return 30;
      case "Ultimate":
        return Infinity;
      default:
        return 0;
    }
  }
}
